<template>
<div class="chapter">
<div class="inner_page">
<div class="cont-sb"><a id="file_005">
</a><h2 class="h2c"><a id="file_005"></a><a id="page_5"><strong>CONTENTS</strong></a></h2><a id="page_5">
</a><p class="cont"><a id="page_5"><span class="smallcaps"></span></a><a class="nounder" href="#/xhtml/file_006#file_006">ACKNOWLEDGMENTS</a></p>
<p class="cont"><span class="smallcaps"><a class="nounder" href="#/xhtml/file_007#file_007">INTRODUCTION</a></span></p>
<p class="cont"><a class="nounder" href="#/xhtml/file_009#file_009"><span class="smallcaps">CHAPTER ONE</span>         <strong>THE HELLCAT’S ORIGINS</strong></a></p>
<p class="cont"><span class="nounder" href="#/xhtml/file_050#file_050" title="Link target outside of Sample"><span class="smallcaps">CHAPTER TWO</span>        <strong>THE HELLCAT’S CONSTRUCTION</strong></span></p>
<p class="cont"><span class="nounder" href="#/xhtml/file_117#file_117" title="Link target outside of Sample"><span class="smallcaps">CHAPTER THREE</span>      <strong>BUILDING THE BEAST</strong></span></p>
<p class="cont"><span class="nounder" href="#/xhtml/file_161#file_161" title="Link target outside of Sample"><span class="smallcaps">CHAPTER FOUR</span>       <strong>COMBAT DEBUT</strong></span></p>
<p class="cont"><span class="nounder" href="#/xhtml/file_205#file_205" title="Link target outside of Sample"><span class="smallcaps">CHAPTER FIVE</span>        <strong>THE YEAR OF WAR</strong></span></p>
<p class="cont"><span class="nounder" href="#/xhtml/file_251#file_251" title="Link target outside of Sample"><span class="smallcaps">CHAPTER SIX</span>          <strong>CLOSING IN</strong></span></p>
<p class="cont"><span class="nounder" href="#/xhtml/file_289#file_289" title="Link target outside of Sample"><span class="smallcaps">CHAPTER SEVEN</span>     <strong>AFTER THE BATTLES</strong></span></p>
<p class="cont"><span class="nounder" href="#/xhtml/file_339#file_339" title="Link target outside of Sample"><span class="smallcaps">SELECTED BIBLIOGRAPHY</span></span></p>
<p class="cont"><span class="smallcaps"><span class="nounder" href="#/xhtml/file_340#file_340" title="Link target outside of Sample">INDEX</span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_005.vue?449d97fc